import Common from '@/services/Api/common';
import { store } from '@/store/store';

/**
 * Fetches and updates Do and Win task count
 * Updates both localStorage and Vuex store
 * @returns {Promise<void>}
 */
export const getDoAndWinTaskCount = async () => {
  try {
    const res = await Common.getTaskCount();
    const taskCounts = res?.data?.Data?.taskCounts;
    if (Array.isArray(taskCounts)) {
      await store.dispatch('app/setActiveDowinList', taskCounts);
    }
  } catch (error) {
    console.error('Error fetching Do and Win task count:', error);
  }
};
